<template>
  <div>
    <collapse title="Información de contacto de la Unidad Contratante">
      <div class="row">
        <div class="col-3">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-input
              v-model="model.contactName"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Nombre:"
            />
          </validation-provider>
          <div v-else-if="isReadOnly" class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Nombre:</span>
            <span>{{ model.contactName | empty }}</span>
          </div>
        </div>
        <div v-if="!isReadOnly" class="col-1">
          <custom-input v-model="model.contactMiddleInitial" label="Inicial:" />
        </div>
        <div v-else-if="isReadOnly" class="col-1">
          <div class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Inicial:</span>
            <span>{{ model.contactMiddleInitial | empty }}</span>
          </div>
        </div>
        <div class="col-4">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-input
              v-model="model.contactPaternalLastName"
              custom-error-msg="El campo es requerido."
              :error="errors[0]"
              label="Apellido Paterno:"
            />
          </validation-provider>
          <div v-else-if="isReadOnly" class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Apellido Paterno:</span>
            <span>{{ model.contactPaternalLastName | empty }}</span>
          </div>
        </div>
        <div v-if="!isReadOnly" class="col-4">
          <custom-input
            v-model="model.contactMaternalLastName"
            label="Apellido Materno:"
          />
        </div>
        <div v-else-if="isReadOnly" class="col-4">
          <div class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Apellido Materno:</span>
            <span>{{ model.contactMaternalLastName | empty }}</span>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            rules="required"
          >
            <custom-drop-down
              v-model="model.contactOffice"
              custom-error-msg="El campo es requerido."
              :disabled="model.contactOffice && offices.length == 1"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Oficina:"
              :options="offices"
            />
          </validation-provider>
          <div v-else-if="isReadOnly" class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Oficina:</span>
            <span>{{ model.contactOffice.name | empty }}</span>
          </div>
        </div>
        <div class="col-3">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            :custom-messages="{
              required: 'El campo es requerido.',
              length: 'El teléfono es invalido',
            }"
            rules="required|length:13"
          >
            <custom-input
              v-model="model.contactPhoneNumber"
              :error="errors[0]"
              label="Teléfono:"
              mask-type="Phone"
              masked
            />
          </validation-provider>
          <div v-else-if="isReadOnly" class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Teléfono:</span>
            <span>{{ model.contactPhoneNumber | empty }}</span>
          </div>
        </div>
        <div class="col-1">
          <custom-input
            v-if="!isReadOnly"
            v-model="model.contactPhoneNumberExt"
            label="Ext:"
            mask-type="PhoneExt"
            masked
          />
          <div v-else-if="isReadOnly" class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Extensión:</span>
            <span>{{ model.contactPhoneNumberExt | empty }}</span>
          </div>
        </div>
        <div class="col-4">
          <validation-provider
            v-if="!isReadOnly"
            v-slot="{ errors }"
            :custom-messages="{
              required: 'El campo es requerido.',
              email: 'El correo electrónico no es válido.',
            }"
            rules="required|email"
          >
            <custom-input
              v-model="model.contactEmail"
              :error="errors[0]"
              label="Correo Electrónico:"
            />
          </validation-provider>
          <div v-else-if="isReadOnly" class="d-flex flex-column my-2">
            <span class="color-gray-6 font-14">Correo Electrónico:</span>
            <span>{{ model.contactEmail | empty }}</span>
          </div>
        </div>
      </div>
    </collapse>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import Collapse from '@/components/common/SimpleCollapse.vue';

export default {
  name: 'ContactInfo',
  components: {
    ValidationProvider,
    CustomInput,
    CustomDropDown,
    Collapse,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    offices: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    showSlot: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
<style scoped></style>
